import React, {useState} from "react";
import {Button, Typography} from "@mui/material";
import YourFilesBlurb from "../../components/yourFilesBlurb/yourFilesBlurb";
import InventionDialog from "../../dialogs/inventionDialog/inventionDialog";

const InventionStep = (props) => {
    const { snackbar, onSaveWizard, onSaveDocument } = props;
    const [ showDialog, setShowDialog ] = useState(false);

    return <>
        <Typography>
            Please tell us about your invention
        </Typography>
        <YourFilesBlurb/>
        <div className="action">
            <Button
                color="primary"
                onClick={() => setShowDialog(true)}
            >
                Answer Questionnaire
            </Button>
        </div>
        {showDialog ?
            <InventionDialog
                snackbar={snackbar}
                onCancel={() => setShowDialog(false)}
                onSave={(wizard, pdf) => {
                    setShowDialog(false);
                    onSaveWizard(wizard);
                    onSaveDocument(pdf);
                }}
            /> : null}
    </>
};

export default InventionStep;
